<tmo-dropdown
  [id]="'tmo-dropdown-multiLine-msisdn-value-1'"
  [disabled]="isSingleLine"
  name="multiLineMsisdnDropDown"
  [options]="options"
  [focusFirstElement]="true"
  (selectionChange)="onSelectionChange($event)"
  [prefix]="'msisdn'"
>
</tmo-dropdown>
